import {iosVhFix} from './utils/ios-vh-fix';
import {initModals} from './modules/modals/init-modals';
import {initAccordions} from './modules/accordions/init-accordion';
import {initProducts} from './modules/products';
import {initCategories} from './modules/categories';
import {CustomSelect} from './modules/select/custom-select';
import {priceSlider} from './modules/price-slider';
import {initFilters} from './modules/filters';
import {initCookieBanner} from './modules/cookie';
import {initMap} from './modules/map';
import {initHeader} from './modules/header';
import {initWelcome} from './modules/welcome';
import {initWork} from './modules/work';
import {initBusiness} from './modules/business';
import {initNews} from './modules/news';
import {initFileUpload} from './modules/file-upload';
import {initTabs} from './modules/tabs/init-tabs';
import {initRecepies} from './modules/recepies';
import {initShops} from './modules/shops';
import {initSocial} from './modules/social';
import {initAbout} from './modules/about';

// ---------------------------------

window.addEventListener('DOMContentLoaded', () => {

  // Utils
  // ---------------------------------

  iosVhFix();

  // Modules
  // ---------------------------------

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initModals();
    initAccordions();
    initProducts();
    initCategories();
    priceSlider();
    const select = new CustomSelect();
    select.init();
    initFilters();
    initCookieBanner();
    initMap();
    initHeader();
    initWelcome();
    initWork();
    initBusiness();
    initFileUpload();
    initTabs();
    initNews();
    initRecepies();
    initShops();
    initSocial();
    initAbout();
  });
});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
